
import { currentUserStore } from '@/store/typed';
import { Component, Vue } from 'vue-property-decorator';
import { NavigationGuardNext, Route } from 'vue-router';

Component.registerHooks(['beforeRouteEnter']);

@Component
export default class Home extends Vue {
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    if (currentUserStore.user) {
      next({ name: 'projects-list' });
    } else {
      next({ name: 'login' });
    }
  }

  render() {
    return null;
  }
}
